import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { ToggleRight } from 'lucide-react';
import { AdminQuickSettingsContent, AdminQuickSettingsProps } from '@/components/admin/AdminQuickSettingsContent';

export default function AdminSuperControlCenterPage() {
  const props = useOutletContext<AdminQuickSettingsProps>();

  return (
    <div className="space-y-6 max-w-4xl mx-auto pb-10">
      <div className="flex items-center gap-3 border-b pb-4">
        <div className="bg-primary/10 p-3 rounded-xl text-primary">
          <ToggleRight className="w-8 h-8" />
        </div>
        <div>
          <h1 className="text-3xl font-display font-black text-slate-800">Super Base de Contrôle</h1>
          <p className="text-muted-foreground text-sm mt-1">
            Gérez toutes les fonctionnalités globales de Kayn'in depuis cette interface centralisée.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border p-2 sm:p-6">
        <AdminQuickSettingsContent {...props} />
      </div>
    </div>
  );
}
